import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "box flexiblock" }
const _hoisted_2 = { class: "d-flex align-items-center mb-2" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = ["title"]
const _hoisted_5 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_6 = {
  key: 1,
  class: "list-unstyled"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  class: "btn btn-link btn-collapse",
  type: "button"
}
const _hoisted_9 = {
  key: 2,
  class: "show-arrow font-weight-bold mb-3"
}
const _hoisted_10 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_loading_container, {
      state: _ctx.state,
      errormsg: "Beim Laden der Anwendungen ist ein Fehler aufgetreten. Bitte probieren Sie es nochmals oder kontaktieren Sie den Help-Desk: help-desk@brz.gv.at"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.header || 'personalisierte Findok Neuzugänge'), 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reload())),
            type: "button",
            class: "btn py-0 text-primary ml-auto",
            id: "rssfindok-refresh-sidebar",
            title: `Aktualisiert am ` + _ctx.getNowFormatted()
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("span", {
              class: "icon icon-ladekreisel",
              "aria-hidden": "true"
            }, null, -1),
            _createElementVNode("span", { class: "sr-only" }, "Daten neuladen", -1)
          ]))], 8, _hoisted_4)
        ]),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Derzeit keine Neuzugänge vorhanden. "))
          : (_openBlock(), _createElementBlock("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.findokItems, (findokItem, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "show-arrow mb-2",
                  key: index
                }, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.getNiceDate(findokItem.pubDate)), 1),
                  (findokItem && findokItem.link)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: _ctx.sanitizeUrl(findokItem.link),
                        target: "_blank",
                        rel: "noopener"
                      }, [
                        _createElementVNode("button", _hoisted_8, [
                          _createTextVNode(_toDisplayString(findokItem.title) + " ", 1),
                          _cache[2] || (_cache[2] = _createElementVNode("span", {
                            class: "icon icon-navigation_pfeil_klein_rechts",
                            "aria-hidden": "true"
                          }, null, -1))
                        ])
                      ], 8, _hoisted_7))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])),
        (_ctx.findokExternalUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("a", {
                href: _ctx.sanitizeUrl(_ctx.findokExternalUrl),
                target: "_blank",
                rel: "noopener"
              }, _toDisplayString(_ctx.findokExternalUrlText ? _ctx.findokExternalUrlText : _ctx.findokExternalUrl), 9, _hoisted_10)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["state"])
  ]))
}